import React, { memo } from 'react';
import { View, TouchableOpacity } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Space, ListItemContainer } from '@redlink/components/atoms';
import { OrderItemStatusIcon } from '@redlink/components/molecules';
import { useLocale } from '@redlink/assets/locale';
import { useValues } from '@redlink/assets/values';
import { useMoneyMask, useDateFormat, useOrderTextColor } from '@redlink/core';

export const OrderItem = memo(
  ({
    item: {
      id,
      contact,
      createDate,
      finalPrice,
      status,
      description,
      items,
    } = {},
    isSelected = false,
    onPress,
  }) => {
    const { styles } = useStyle();
    const { staticData } = useValues();
    const { dictionary } = useLocale();
    const { getValue } = useMoneyMask();
    const { getRelativeDateString } = useDateFormat();
    const titleText = `${items.length} ${dictionary.items}`;
    const finalPriceText = `${getValue(finalPrice)} ${dictionary.moneyPostfix}`;
    const isNewOrder = status === staticData.orderStatus.new;
    const shouldBeShowStartSpace = !isNewOrder;
    const { bodyColor, additionalColor, priceColor } = useOrderTextColor({
      status,
      isSelected,
    });
    const createDateText = getRelativeDateString(createDate);

    return (
      <TouchableOpacity activeOpacity={0.6} {...{ onPress }}>
        <ListItemContainer
          StartComponent={
            <View style={styles.statisticsContainer}>
              <Text style={[styles.titleText, { color: additionalColor }]}>
                {createDateText}
              </Text>
              <Text style={[styles.subtitle2Text, { color: additionalColor }]}>
                {dictionary.reserved}
              </Text>
            </View>
          }
          EndComponent={
            <Text style={[styles.titleText, { color: priceColor }]}>
              {finalPriceText}
            </Text>
          }
        >
          <View style={styles.bodyMainContainer}>
            <OrderItemStatusIcon {...{ status }} color={bodyColor} />
            {shouldBeShowStartSpace && <Space size={15} />}
            <View style={styles.bodyContainer}>
              <View>
                <Text style={[styles.titleText, { color: bodyColor }]}>
                  {titleText}
                </Text>
                <Text style={[styles.subtitleText, { color: bodyColor }]}>
                  {contact}
                </Text>
              </View>
            </View>
          </View>
        </ListItemContainer>
      </TouchableOpacity>
    );
  }
);

const useStyle = createUseStyle(({ colors, size, shadow }) => ({
  image: {
    width: 87,
    height: 49,
  },
  titleText: {
    fontWeight: 'bold',
    fontSize: 16,
    color: colors.gray23,
  },
  subtitleText: {
    fontSize: 16,
    color: colors.gray21,
  },
  subtitle2Text: {
    fontSize: 12,
    color: colors.gray21,
  },
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 16,
  },
  bodyMainContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  bodyContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
}));
